<template>
  <form novalidate class="form" @submit.prevent="submit">
    <p>
      As a protection against automated spam, you'll need to type in the
      characters that appear in this image.
    </p>
    <div class="svg">
      <span v-html="data.svg"></span>
      <md-button @click="refresh" class="md-simple md-just-icon">
        <md-icon>cached</md-icon>
      </md-button>
    </div>
    <br />
    <md-field>
      <label>Please type the characters</label>
      <md-input v-model="inputValue"></md-input>
    </md-field>
    <br /><br />
    <md-button
      type="submit"
      class="md-dense md-raised md-primary md-simple md-just-icon"
    >
      <md-icon>keyboard_arrow_right</md-icon>
    </md-button>
  </form>
</template>

<script>
import { captchaApi } from '@/api/http/api';

export default {
  data() {
    return {
      inputValue: null,
    };
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  methods: {
    refresh() {
      this.$emit('on-fail');
    },
    submit() {
      try {
        if (!this.inputValue) return;
        captchaApi
          .submit(this.data.source, this.inputValue)
          .then((response) => {
            if (!response.data.result) {
              this.inputValue = null;
              this.$emit('on-fail');
            } else {
              this.$emit('on-success');
            }
          })
          .catch((err) => {
            console.error(err);
          });
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.form {
  text-align: center;
}
.svg {
  display: inline-block;
  border: 1px solid #000000;
  padding: 2px;
  margin-bottom: 10px;
  .md-button {
    margin-top: 10px;
  }
}
.md-field {
  width: 70%;
  margin: 0 auto;
}
</style>
